import TokenService from '@/services/token'
import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: ''
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error
}

// mutations
const mutations = {
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    const tempData = state.data
    tempData.push(model)
    Vue.set(state, 'data', tempData)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    const index = state.data.findIndex(m => m.id === model.id)
    state.data[index] = model
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  setError(state, error) {
    state.error = error
  }
}

const actions = {
  listAll({ commit, state }) {
    return TokenService.listAll().then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  findAll({ commit, state }, options) {
    return TokenService.findAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  save({ commit, state }, model) {
    if (!model.id || model.isClone) {
      return TokenService.create(model).then((res) => {
        if (res.result) {
          commit('appendData', res.result)
          return res
        }
        const error = (res && res.response && res.response.data) ? res.response.data : res
        commit('setError', error)
        return Promise.reject(error)
      })
    } else {
      return TokenService.update(model).then((res) => {
        if (res.result) {
          commit('updateData', res.result)
          return res
        }
        const error = (res && res.response && res.response.data) ? res.response.data : res
        commit('setError', error)
        return Promise.reject(error)
      })
    }
  },
  delete({ commit, state }, id) {
    return TokenService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
